import { t } from "../lib/i18n";
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const InsufficientCreditsModal: React.FC = () => {
    const [isOpen, setIsOpen] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        const handleDepleted = () => {
            setIsOpen(true);
        };
        window.addEventListener('credits-depleted', handleDepleted);
        return () => {
            window.removeEventListener('credits-depleted', handleDepleted);
        };
    }, []);

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm">
            <div className="bg-bg-primary border border-border-primary rounded-2xl max-w-2xl w-full mx-4 overflow-hidden shadow-2xl relative">
                {/* Close button */}
                <button 
                    onClick={() => setIsOpen(false)} 
                    className="absolute top-4 right-4 text-text-secondary hover:text-text-primary transition-colors z-10 p-2 hover:bg-bg-secondary rounded-full font-bold text-lg"
                    style={{ lineHeight: 1 }}
                >
                    ✕
                </button>

                <div className="p-8">
                    {/* Header */}
                    <div className="flex flex-col items-center text-center mb-8">
                        <div className="w-16 h-16 bg-yellow-500/10 border border-yellow-500/30 rounded-full flex items-center justify-center text-3xl mb-4">
                            🪙
                        </div>
                        <h2 className="text-3xl font-extrabold text-text-primary mb-2">{t("insufficientCreditsModal.k1")}</h2>
                        <p className="text-text-secondary max-w-md text-sm">
                            {t("insufficientCreditsModal.k2")} </p>
                    </div>

                    {/* Features list */}
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-8 bg-bg-secondary p-5 rounded-xl border border-border-primary text-left">
                        <div className="flex gap-3">
                            <div className="text-yellow-500 font-bold mt-0.5">✓</div>
                            <div>
                                <h4 className="font-semibold text-text-primary text-sm">{t("insufficientCreditsModal.k3")}</h4>
                                <p className="text-xs text-text-secondary">{t("insufficientCreditsModal.k4")}</p>
                            </div>
                        </div>
                        <div className="flex gap-3">
                            <div className="text-yellow-500 font-bold mt-0.5">✓</div>
                            <div>
                                <h4 className="font-semibold text-text-primary text-sm">{t("insufficientCreditsModal.k5")}</h4>
                                <p className="text-xs text-text-secondary">{t("insufficientCreditsModal.k6")}</p>
                            </div>
                        </div>
                        <div className="flex gap-3">
                            <div className="text-yellow-500 font-bold mt-0.5">✓</div>
                            <div>
                                <h4 className="font-semibold text-text-primary text-sm">{t("insufficientCreditsModal.k7")}</h4>
                                <p className="text-xs text-text-secondary">{t("insufficientCreditsModal.k8")}</p>
                            </div>
                        </div>
                        <div className="flex gap-3">
                            <div className="text-yellow-500 font-bold mt-0.5">✓</div>
                            <div>
                                <h4 className="font-semibold text-text-primary text-sm">{t("insufficientCreditsModal.k9")}</h4>
                                <p className="text-xs text-text-secondary">{t("insufficientCreditsModal.k10")}</p>
                            </div>
                        </div>
                    </div>

                    {/* CTA */}
                    <div className="bg-gradient-to-r from-blue-600/10 to-indigo-600/10 border border-blue-500/30 rounded-xl p-6 flex flex-col sm:flex-row items-center justify-between gap-4">
                        <div className="flex items-center gap-4 text-left">
                            <div className="bg-blue-600/20 text-2xl p-3 rounded-lg border border-blue-500/20 flex items-center justify-center w-12 h-12">
                                👑
                            </div>
                            <div>
                                <h3 className="font-bold text-text-primary text-lg">{t("insufficientCreditsModal.k11")}</h3>
                                <p className="text-xs text-text-secondary">{t("insufficientCreditsModal.k12")}</p>
                            </div>
                        </div>
                        <button
                            onClick={() => {
                                setIsOpen(false);
                                navigate('/account');
                            }}
                            className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-3 px-6 rounded-lg transition-all flex items-center gap-2 whitespace-nowrap shadow-lg shadow-blue-500/20"
                        >
                            {t("insufficientCreditsModal.k13")} <span className="text-lg">→</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default InsufficientCreditsModal;
